export default "__VITE_ASSET__97724866__"